import * as React from "react";
import { connect } from "react-redux";
import { selectIsFortuneTellerEventRunning } from "../../../selectors/selectFortuneTellerEventInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { IdBigCharacter } from "../../generic/big-character/IdBigCharacter";
import { DialogFarmEvent } from "../../generic/farm-event/DialogFarmEvent";
import { FortuneTellerEventDetails } from "./FortuneTellerEventDetails";
var _DialogFortuneTellerEvent = function (_a) {
    var shouldRender = _a.shouldRender;
    if (!shouldRender) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(DialogFarmEvent, { eventTitleLoca: IdLoca.fortuneTellerEvent_title, eventDescriptionLoca: IdLoca.fortuneTellerEvent_desc, eventCharacter: IdBigCharacter.BigCharacter_Eva_FortuneTeller, eventCharacterClassName: "flex__full" },
        React.createElement(FortuneTellerEventDetails, null)));
};
var mapState = function (state) { return ({
    shouldRender: selectIsFortuneTellerEventRunning(state),
}); };
export var DialogFortuneTellerEvent = connect(mapState)(_DialogFortuneTellerEvent);



//////////////////
// WEBPACK FOOTER
// ./src/features/fortune-teller-event/components/DialogFortuneTellerEvent.tsx
// module id = 2835
// module chunks = 3